import { MuiOtpInput } from "mui-one-time-password-input";
import { Controller } from "react-hook-form";
import Typography from "@mui/material/Typography";
import { getReactHookFormNestedError } from "../../utils/errors";
import { INPUT_COLOR_BORDER } from "../../utils/colors";

const OTPField = ({
  control,
  rules = {},
  length = 6,
  errors = {},
  label = "",
  subLabel = "",
  variant = "standard",
  name = "",
  value = "",
  disabled = false,
  sx,
  otpContainerSx = {},
  otpBoxSx = {},
  otpInputSx = {},
}) => {
  const error = getReactHookFormNestedError(errors, name);
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={value}
      render={({ field }) => (
        <>
          {label && (
            <Typography variant="body1" color={error ? "error" : "default"}>
              {label}
            </Typography>
          )}
          {subLabel && (
            <Typography variant="body2" color="textSecondary">
              {subLabel}
            </Typography>
          )}
          <MuiOtpInput
            {...field}
            length={length}
            sx={{
              width: "100%",
              justifyContent: "center",
              gap: 2,
              ...otpContainerSx,
            }}
            TextFieldsProps={{
              disabled,
              placeholder: "-",
              variant,
              sx: {
                ...sx,
                "& .MuiInputBase-root": {
                  width: 56,
                  height: 56,
                  border: `1px solid ${INPUT_COLOR_BORDER}`,
                  borderRadius: 8,
                  overflow: "hidden",
                  ...otpBoxSx,
                },
                ".MuiInputBase-input": {
                  py: 0,
                  height: "100%",
                  textAlign: "center",
                  fontSize: 20,
                  lineHeight: "56px",
                  ...otpInputSx,
                },
                "& .MuiFilledInput-root": {
                  backgroundColor: "transparent",
                },
                "& .MuiFilledInput-root:before, & .MuiFilledInput-root:after": {
                  display: "none",
                },
              },
            }}
          />
          {error && (
            <Typography variant="caption" color="error">
              {error?.message}
            </Typography>
          )}
        </>
      )}
    />
  );
};

export default OTPField;
